<div *ngIf="userloaded == true" style="background: url('assets/layout/images/bgflower.svg') no-repeat right center,
    linear-gradient(178deg, rgba(255,255,255,1) 0%, rgba(251,238,250,1) 100%);
    background-size: contain;
    height: 100vh;
    height: 100dvh;">


    <div class="layout-container" [ngClass]="containerClass">
        <app-topbar></app-topbar>
        <app-sidebar></app-sidebar>
        <div class="layout-content-wrapper">
            <div class="layout-content">
                <div class="layout-content-inner">
                    <app-breadcrumb></app-breadcrumb>
                    <router-outlet></router-outlet>
                    <app-footer></app-footer>
                </div>
            </div>
        </div>
        <app-config></app-config>
    </div>
</div>
